/**
 * Permission constants for the application
 *
 * These constants represent permission names that come from the API response
 * and are stored in IndexDB. Using constants instead of hardcoded strings
 * provides:
 * - Type safety
 * - Centralized management
 * - Easy refactoring
 * - Better IDE autocomplete
 * - Reduced typo errors
 *
 * Note: These values must match the permission names returned from the API.
 */
export const AUTHX_APP_ID = 9;
export const AUTHX_PERMISSIONS_VERSION = '1';

export const PERMISSIONS = {
    // Project Permissions
    CREATE_NEW_PROJECT: 'create_new_project',
    EDIT_PROJECT_CONFIGURATION: 'edit_project_configuration',
    ASSIGN_PROJECT_ROLES: 'assign_project_roles',
    ACCESS_PROJECT_CONFIGURATION: 'access_project_configuration',

    // Content Permissions
    CREATE_CONTENT: 'create_content',
    EDIT_OWN_CONTENT: 'edit_own_content',
    EDIT_ANY_CONTENT: 'edit_any_content',
    DELETE_OWN_CONTENT: 'delete_own_content',
    DELETE_ANY_CONTENT: 'delete_any_content',
    VIEW_ALL_CONTENT: 'view_all_content',
    VIEW_ASSIGNED_CONTENT: 'view_assigned_content',
    COMMENT: 'comment',
    CHANGE_ALLOTMENT: 'change_allotment',
    APPROVE_REJECT_ASSIGNED_CONTENT: 'approve_reject_assigned_content',
    APPROVE_REJECT_ANY_CONTENT: 'approve_reject_any_content',
    DROP_QUESTION_FROM_SCORING: 'drop_question_from_scoring',
    BULK_EDIT: 'bulk_edit',

    // Image Permissions
    VIEW_ALL_IMAGES: 'view_all_images',
    UPLOAD_FINAL_IMAGES: 'upload_final_images',
    DELETE_IMAGES: 'delete_images',
    APPROVE_IMAGES: 'approve_images',

    // Translation Permissions
    EDIT_TRANSLATIONS_OWN: 'edit_translations_own',
    APPROVE_TRANSLATIONS: 'approve_translations',

    // AI Permissions
    ACCESS_AI_FOR_QUESTION_VARIATION: 'access_ai_for_question_variation',
    SKILL_TREE_CREATE_READ: 'skill_tree_create_read',
} as const;

/**
 * Type-safe permission name type
 * Allows TypeScript to infer the exact permission value types
 */
export type PermissionValue = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
